import { useGetPartnerQuery } from '@/api/api.slice';
import { CompanyFields } from '@/features/PartnerInfo/fields/CompanyFields.tsx';
import { PartnerFields } from '@/features/PartnerInfo/fields/PartnerFields.tsx';
import { Card, Loader } from '@arsnovasystems/ars-front-lib';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * PartnerInfo component
 *
 * @returns JSX of the component
 */
const PartnerInfo = () => {
  const { t } = useTranslation();
  const { data: me } = useGetPartnerQuery();

  if (!me) return <Loader />;

  return (
    <Stack
      direction={'row'}
      sx={{ gap: 2 }}
    >
      <Card
        sx={{
          flex: 1,
        }}
        Avatar={<AccountCircle />}
        title={`${me.firstName} ${me.lastName}`}
        subtitle={t('ik.partnerInfo.subheader')}
      >
        <PartnerFields me={me} />
      </Card>
      <Card
        sx={{
          flex: 1,
        }}
        Avatar={<AccountCircle />}
        title={t('ik.partnerInfo.company.title')}
        subtitle={t('ik.partnerInfo.company.subheader')}
      >
        <CompanyFields me={me} />
      </Card>
    </Stack>
  );
};

export default PartnerInfo;
